<template>
  <b-modal
      id="file-intervention-delete-modal"
      :title="'Supprimer un ' + $t('file')"
      @ok="handleOk"
      :ok-title="$t('Delete')"
      ok-variant="danger"
      :cancel-title="$t('Cancel')"
      cancel-variant="danger"
  >

    <div>
      {{ $t('Delete') }} le {{ $t('file') }} "{{ $props.file ? $props.file.name : ""}}" ?
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api';

export default {

  name: 'FileInterventionDeleteModal',

  props: {
    file: Object
  },

  emits: ['didDeleteFileIntervention'],


  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      api
        .delete(`/fileIntervention/${this.$props.file.id}`)
        .then(response => {
          this.$emit('didDeleteFileIntervention')
          this.hideModal()
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('file-intervention-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/intervention/FileInterventionDeleteModal.vue